"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WelcomeHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="221772" id="hero-introduction" className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-background py-[120px]">
      {}
      <div className="absolute inset-0 bg-background" />
      
      {}
      <div className="absolute inset-0 bg-transparent" />

      {}
      <div className="relative z-10 mx-auto flex h-full w-full max-w-6xl flex-col items-center justify-between text-center !p-[32px]">
        
        {}
        <div className="flex-1" />

        {}
        <div className="flex flex-col items-center justify-center">
          <span className="mb-4 font-default text-xs font-bold tracking-widest text-secondary uppercase sm:text-sm md:text-lg">
            Elevating Corporate Environments
          </span>
          <h1 className="font-default text-3xl font-bold tracking-tight text-chart-5 sm:text-4xl md:text-5xl lg:text-[72px]">Services</h1>
          <div className="mt-12 w-full max-w-4xl overflow-hidden shadow-xl">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645819/img/DLR-Laptop-16x9-1.png" alt="Architectural Abstract" className="h-full w-full object-cover" />
          </div>
        </div>

        {}
        <div className="flex-1" />

        {}
        <div ref={ref} className={`mt-auto transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-[20px] opacity-0"}`}>
          <Button asChild className="h-14 rounded-lg bg-primary px-10 font-default text-lg font-bold text-secondary shadow-lg hover:bg-primary/90 transition-colors">
            <Link to="/FeelGoodWorksServicesPage">View Our Portfolio</Link>
          </Button>
        </div>
      </div>
    </section>;
}